(function () {
  var dialog = document.querySelector('[data-premium-dialog]');
  if (!dialog) return;

  document.querySelectorAll('[data-premium-open]').forEach(function (btn) {
    btn.addEventListener('click', function () { dialog.showModal(); });
  });
  document.querySelectorAll('[data-premium-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { dialog.close(); });
  });
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) dialog.close();
  });

  var tabs = dialog.querySelectorAll('[data-tab]');
  var panels = dialog.querySelectorAll('[data-panel]');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var id = tab.getAttribute('data-tab');
      tabs.forEach(function (t) {
        t.classList.toggle('is-active', t === tab);
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var active = p.getAttribute('data-panel') === id;
        p.classList.toggle('is-active', active);
        p.hidden = !active;
      });
    });
  });
})();
